import { IconButton, Stack } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import NotificationMenu from '../../../components/notifications/NotificationMenu';
import UserMenuDropdown from './UserMenuDropdown';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/layout-icons/CalendarIcon.svg';
import { ReactComponent as MessageIcon } from '../../../assets/icons/layout-icons/MessageIcon.svg';
import useMode from '../../../utils/hooks/useMode';
import { EnumMode } from '../../../utils/context/Mode.context';
import LanguageSwitcher from '../../../components/laguage-switcher/LanguageSwitcher';

const RightSideToolbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mode } = useMode();
  const path = location.pathname;

  const showLanguageSwitcher = path.startsWith('/dashboard');

  const showButtons = path.startsWith('/dashboard') && !path.includes('/create-company');

  return (
    <Stack
      spacing="15px"
      direction="row"
      sx={{ pr: path.includes('dashboard') || path.includes('admin') ? '24px' : 0 }}
    >
      {showButtons && (
        <IconButton
          className="react-joyride-step-2"
          size="large"
          sx={{
            border: '1px solid #BFC6D7',
          }}
          onClick={() => navigate('/dashboard/chat')}
        >
          <MessageIcon
            fill={mode === EnumMode.Supplier && path.startsWith('/dashboard') ? '#FFF' : '#79829B'}
          />
        </IconButton>
      )}

      {showButtons && (
        <IconButton
          className="react-joyride-step-3"
          size="large"
          sx={{
            border: '1px solid #BFC6D7',
          }}
          onClick={() => navigate('/dashboard/calendar')}
        >
          <CalendarIcon
            fill={mode === EnumMode.Supplier && path.startsWith('/dashboard') ? '#FFF' : '#79829B'}
          />
        </IconButton>
      )}

      {showButtons && <NotificationMenu />}
      <UserMenuDropdown />
      {showLanguageSwitcher && (
        <LanguageSwitcher variant={mode === EnumMode.Supplier ? 'primary' : 'secondary'} />
      )}
    </Stack>
  );
};
export default RightSideToolbar;
